import * as React from 'react'
import GridItem from '../../grid/GridItem'
import GridContainer from '../../grid/GridContainer'
import CustomTabs from '../../tab/CustomTabs'
import DirectionsRunIcon from '@material-ui/icons/DirectionsRun'
import PeopleIcon from '@material-ui/icons/People'
import DepartmentNewDepartures from './DepartmentNewDepartures'
import DepartmentSignedDepartures from './DepartmentSignedDepartures'

export default function DepartmentDeparturesTab({ department }) {
  return (
    <GridContainer>
      <GridItem xs={12} sm={12} md={12}>
        <CustomTabs
          headerColor="primary"
          tabs={[
            {
              tabName: 'Neue Auszüge',
              tabIcon: DirectionsRunIcon,
              tabContent: <DepartmentNewDepartures departmentName={department}/>,
            },
            {
              tabName: 'Unterschriebene Auszüge',
              tabIcon: PeopleIcon,
              tabContent: <DepartmentSignedDepartures departmentName={department}/>,
            },
          ]}
        />
      </GridItem>
    </GridContainer>
  )
}
